<template lang="html">
  <div class="qrcode-cover">
    <div class="holder"></div>
    <div class="qrcode-cover-main">
      <div class="next">
        <img src="../../assets/images/article-next.png" alt="">
      </div>
      <p class="qrcode-cover-f">关注作者授权公众号继续阅读</p>
      <p class="qrcode-cover-s">由于版权问题 请关注后继续阅读</p>
      <div class="qrcode">
        <img src="//edu-wps.ks3-cn-beijing.ksyun.com/static_file/pictures/qrcode/3ae9d9b598174a49aacb575184bbadfd.png" alt="">
      </div>
    </div>

  </div>
</template>

<script>
  export default {
    name: 'QrcodeCover'
  }

</script>

<style lang="scss" scoped>
  @charset "UTF-8";
  @import "../../style/main";
  @keyframes nextMove {
    0% {
      transform: translateY(rem(-20));
    }
    50% {
      transform: translateY(rem(0));
    }
    100% {
      transform: translateY(rem(-20));
    }
  }
  .qrcode-cover {
    text-align: center;
    .holder {
      height: rem(100);
      background: linear-gradient(-180deg, rgba(255, 255, 255, 0) 0 ,rgba(255, 255, 255, .7) 30% ,#FFF 100%);
    }

    .next {
      animation: nextMove 1.2s infinite linear;
      img {
        width: rem(20);
      }
    }
    &-main {
      background: #FFF;
    }
    &-f {
      font-size: rem(28);
      width: rem(460);
      height: rem(60);
      line-height: rem(60);
      margin: auto;
      margin-bottom: rem(16);
      border: rem(4) solid #FF8951;
      border-radius: rem(50);
      color: #FF8951;
      font-weight: bold;
      box-shadow: 0 rem(6) rem(14) 0 rgba($color: #FF8C55, $alpha: .28);
    }

    &-s {
      font-size: rem(24);
      color: #333333;
      margin-bottom: rem(19);
    }

    .qrcode {
      > img {
        width: rem(210);
        height: rem(210);
      }
    }
  }

</style>
